import { render, staticRenderFns } from "./ActionIngresarABodegaPorEsperaDePartes.vue?vue&type=template&id=7ce4356b&lang=pug"
import script from "./ActionIngresarABodegaPorEsperaDePartes.vue?vue&type=script&lang=js"
export * from "./ActionIngresarABodegaPorEsperaDePartes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports